import React from "react";
import "./TrustedPartners.css";

import sampathLogo from "../../assets/logo/sampath.svg";
import lankaLogo from "../../assets/logo/lankapaylogo.png";
// import govPayLogo from "../../assets/logo/govpaylogo.png";

const TrustedPartners = () => {
  const logos = [sampathLogo, lankaLogo];

  return (
    <div className="trusted-partners-container">
      <h2 className="trusted-title">
        Trusted Partnerships <br /> and Successful Collaborations
      </h2>

      <div className="logos-wrapper">
        <div className="logos-track">
          {logos.concat(logos).map((logo, index) => (
            <div className="logo-item" key={index}>
              <img src={logo} alt={`partner-${index}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustedPartners;
